import { render } from "./AnalysisMarginTiles.vue?vue&type=template&id=61975570&scoped=true"
import script from "./AnalysisMarginTiles.vue?vue&type=script&lang=js"
export * from "./AnalysisMarginTiles.vue?vue&type=script&lang=js"

import "./AnalysisMarginTiles.vue?vue&type=style&index=0&id=61975570&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61975570"]])

export default __exports__